import { render, staticRenderFns } from "./LastThreadMsgs.vue?vue&type=template&id=735d7dd5&scoped=true"
import script from "./LastThreadMsgs.vue?vue&type=script&lang=js"
export * from "./LastThreadMsgs.vue?vue&type=script&lang=js"
import style0 from "./LastThreadMsgs.vue?vue&type=style&index=0&id=735d7dd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735d7dd5",
  null
  
)

export default component.exports